module.exports = __webpack_public_path__ + "img/disc-i.3f16be31.png";